var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcondashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_dashboard",
    "data-name": "icon dashboard",
    transform: "translate(-120 -6308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_22386",
    "data-name": "Ret\\xE2ngulo 22386",
    transform: "translate(120 6308)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 20,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.9,
    y: 0.9,
    width: 13.2,
    height: 18.2,
    rx: 1.1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_22389",
    "data-name": "Ret\\xE2ngulo 22389",
    transform: "translate(138 6322)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 19,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.9,
    y: 0.9,
    width: 13.2,
    height: 17.2,
    rx: 1.1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_22387",
    "data-name": "Ret\\xE2ngulo 22387",
    transform: "translate(120 6330)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 11,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.9,
    y: 0.9,
    width: 13.2,
    height: 9.2,
    rx: 1.1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_22388",
    "data-name": "Ret\\xE2ngulo 22388",
    transform: "translate(138 6308)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 11,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.9,
    y: 0.9,
    width: 13.2,
    height: 9.2,
    rx: 1.1,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcondashboard);
export default __webpack_public_path__ + "static/media/icon dashboard.ec775d53835be73a217ad667754a5bc3.svg";
export { ForwardRef as ReactComponent };